export const SAML_MICROSOFT_REPLY_URL_BASE =
  "https://me.incendium.ai/user/auth/saml/microsoft/acs";

export function buildSamlMicrosoftReplyUrl(tenantId: string): string {
  return `${SAML_MICROSOFT_REPLY_URL_BASE}/${tenantId}`;
}

export function buildSamlClientSetupInstructionsText(params: {
  tenantId: string;
  entityId?: string;
}): string {
  const replyUrl = buildSamlMicrosoftReplyUrl(params.tenantId);
  const entityId = params.entityId || "your entity ID";

  return `Microsoft Entra SAML setup for Incendium

Use your organization's Microsoft Entra ID tenant to configure SSO with Incendium. Any Entra ID tenant is supported; Entra ID is required.

1. In Microsoft Entra, create or configure an Enterprise application with SAML single sign-on.

2. Ensure "Require verification certificates" is disabled (unchecked).

3. Set the Reply URL (Assertion Consumer Service URL) to:
${replyUrl}

4. Set the enterprise application name (this is the Entity ID) to:
${entityId}

5. From the application's SAML configuration, copy the App Federation Metadata URL and send it to your Incendium contact.

6. After Incendium receives the Federation Metadata URL, we will complete SSO configuration on our side.

`;
}
